import { ObstacleMapData } from "../ObstacleMapData";
import { ObstacleSettings } from "../ObstacleSettings";



export class HammerObsMapData extends ObstacleMapData {
    /**
     * (RO) Pozice kladiva (-1 = vlevo, 1 = vpravo) pri dosazeni pozice hrace na ose Z
     */
    get targetPos(): number { return this._targetPos; }
    private _targetPos: number;

    //-------------------------------------------------------------------------
    /**
     * Konstruktor
     * @param cellId Index bunky
     * @param targetPos Pozice kladiva (-1 = vlevo, 1 = vpravo pri dosazeni pozice hrace na ose Z)
     */
    //-------------------------------------------------------------------------
    constructor(cellId: number, targetPos: number, settings: ObstacleSettings) {
        super(cellId, settings);

        this._targetPos = targetPos;
    }
}